import { Box, Paper, Typography } from '@mui/material';

export default function ClaimModuleHeading({ moduleName, pageName }) {
  return (
    <Paper
      elevation={1}
      sx={{
        position: 'relative',
        mt: '72px',
        ml: { xs: 2, md: '272px' },
        mb: { xs: '-68px', md: '-84px' },
        maxWidth: { xs: 'calc(100vw - 32px)', md: 'calc(100vw - 304px)' },
        width: 'fit-content',
        px: 1.75,
        py: 0.75,
        border: '1px solid',
        borderColor: 'primary.light',
        borderRadius: 2,
        bgcolor: 'rgba(255,255,255,0.97)',
        backdropFilter: 'blur(8px)',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
        <Typography noWrap sx={{ fontSize: 13, fontWeight: 800, color: 'primary.main' }}>{moduleName}</Typography>
        <Typography sx={{ color: 'text.disabled' }}>/</Typography>
        <Typography noWrap sx={{ fontSize: 13, fontWeight: 600, color: 'text.secondary' }}>{pageName}</Typography>
      </Box>
    </Paper>
  );
}
